const NotAllowed = () => (
   <p className="text-green">Acesso Negado! </p>
  )
  
  export default NotAllowed